var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('input',{ref:"excel-upload-input",staticClass:"excel-upload-input",attrs:{"type":"file","accept":".xlsx, .xls"},on:{"change":_vm.handleClick}}),_c('el-button',{attrs:{"loading":_vm.loading,"size":"mini","type":"primary"},on:{"click":_vm.handleUpload}},[_vm._v(" 选择文件 ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }